import { useEffect } from "react";
import { useAppDispatch } from "./hooks";
import { consentInitialisationRequested } from "./slices/consentSlice";
import { featureFlagsLoadRequested } from "./slices/featureFlagsSlice";

export const useClientStateInitialisation = (): void => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(featureFlagsLoadRequested());
    dispatch(consentInitialisationRequested());
  }, [dispatch]);
};
